"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Quote = void 0;
var create_entity_1 = require("../../utils/create-entity");
var gql = String.raw;
exports.Quote = {
  name: 'Quote',
  table: {
    fieldNames: ["person", "description"]
  },
  autoRoutes: ['list', 'create', 'update'],
  form: {
    modal: {
      maxWidth: "800px"
    },
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      person: {
        type: 'linked',
        focus: true,
        required: true,
        entityTypeName: 'Person',
        description: 'Who was the {{PERSON}} who said this?'
      },
      description: {
        type: 'description',
        required: true,
        description: 'What was said by this {{PERSON}}?'
      }
    })
  },
  update: {
    queryFields: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      person { id name openGraph { id image { id url } } photo { id url } }\n      description { id text }\n    "], ["\n      person { id name openGraph { id image { id url } } photo { id url } }\n      description { id text }\n    "])))
  }
};
var templateObject_1;